import { LabelData } from './label-data';
import { Variant } from '../product/dto/variant';

export class PopsInventoryLabelData extends LabelData {
  protected override getGridSizeHelperForCapsules(variant: Variant): string | null {
    const n = variant?.packagedQuantity ?? 0;
    return `${n} Capsule`
      .pluralizer()
      .addRule({ isPlural: n > 1, useApostrophe: false, word: 'Capsule' })
      .pluralize();
  }
}
